import { render, staticRenderFns } from "./NumShow.vue?vue&type=template&id=0f7630a0&"
import script from "./NumShow.vue?vue&type=script&lang=js&"
export * from "./NumShow.vue?vue&type=script&lang=js&"
import style0 from "./NumShow.vue?vue&type=style&index=0&id=0f7630a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports